import router from './router'
import buyMessages from './localization'

export default {
  router,
  localization: buyMessages,
}
